import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    backgroundColor: "#EDF5FB",
    border: "none",
    padding: "20px",
    borderRadius: "12px",
    marginTop: "15px",
  },
  boxTitle: {
    color: "#308CDB",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    "& span": {
      fontSize: "12px",
    },
  },
  boxSubtitle: {
    color: "#667085",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
  },
  boxText: {
    color: "#667085",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    textAlign: "justify",
    textJustify: "inter-word",
  },
  taskText: {
    color: "#667085",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
  circleIcon: {
    overflow: "inherit",
    marginTop: "3px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "34px",
    height: "34px",
    "&:hover": {
      background: "#CCDEEE",
      borderRadius: "50%",
    },
    "& svg": {
      height: "100%",
      width: "70%",
    },
  },
}));

export default styles;
